import { makeHasEnded } from '@/competitions/_common/utils.ts';

import { AUGUST_2025_CAMPAIGN_END_DATE } from '../../../config.ts';

export const useHasEnded = makeHasEnded(AUGUST_2025_CAMPAIGN_END_DATE);
